import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import "./AbsenceLimits.css"

import { getLimits } from "../../../../actions/absenceActions";

class AbsenceList extends React.Component {
    componentDidMount() {
        this.props.getLimits();
    }

    render() {
        return (
            <React.Fragment>
                <div className="absence-limits-component ui container">
                    <div className="ui two item menu">
                        <Link to="/absence" className="item">
                            <div className="content">Wykaz nieobecności</div>
                        </Link>
                        <Link to="/absence/limits" className="active item">
                            <div className="content">Wymiar urlopu</div>
                        </Link>
                    </div>
                    <div className="ui divider" />
                    <div className="ui container">
                        {this.props.limits.userID ? (
                            <React.Fragment>
                                <div className="ui grid">
                                    <div className="row">
                                        <div className="four wide column">
                                            <div className="header content">Podstawowy wymiar urlopu:</div>
                                        </div>
                                        <div className="twelve wide column">
                                            <div className="content">{this.props.limits.baseDays}</div>
                                        </div>
                                    </div>
                                    <div className="ui divider" />
                                    <div className="row">
                                        <div className="four wide column" />
                                        <div className="four wide column">
                                            <div className="header content">Wymiar urlopu</div>
                                        </div>
                                        <div className="four wide column">
                                            <div className="header content">Pozostały do wykorzystania</div>
                                        </div>
                                        <div className="four wide column">
                                            <div className="header content">Wykorzystany</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="four wide column">
                                            <div className="header content">Bieżący:</div>
                                        </div>
                                        <div className="four wide column">
                                            <div className="content">{this.props.limits.currentDays}</div>
                                        </div>
                                        <div className="four wide column">
                                            <div className="content">{this.props.limits.remainingCurrentDays}</div>
                                        </div>
                                        <div className="four wide column" />
                                    </div>
                                    <div className="row">
                                        <div className="four wide column">
                                            <div className="header content">Zaległy:</div>
                                        </div>
                                        <div className="four wide column">
                                            <div className="content">{this.props.limits.outstandingDays}</div>
                                        </div>
                                        <div className="four wide column">
                                            <div className="content">{this.props.limits.remainingOutstandingDays}</div>
                                        </div>
                                        <div className="four wide column" />
                                    </div>
                                    <div className="ui divider" />
                                    <div className="row">
                                        <div className="four wide column">
                                            <div className="header content">Łącznie:</div>
                                        </div>
                                        <div className="four wide column">
                                            <div className="content">{this.props.limits.totalDays}</div>
                                        </div>
                                        <div className="four wide column">
                                            <div className="content">{this.props.limits.remainingDays}</div>
                                        </div>
                                        <div className="four wide column">
                                            <div className="content">{this.props.limits.usedDays}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="four wide column" />
                                        <div className="four wide column">
                                            <div className="header content">W tym na żądanie:</div>
                                        </div>
                                        <div className="four wide column">
                                            <div className="content">{this.props.limits.remainingOnRequest}</div>
                                        </div>
                                        <div className="four wide column">
                                            <div className="content">{this.props.limits.usedOnRequest}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ui divider" />
                                <div className="footer content">
                                    <p>Wymiar urlopu zaktualizoany dnia: <b>{this.props.limits.createdOn}</b></p>
                                </div>
                            </React.Fragment>
                        ) : (
                            <div className="ui large header">
                                <div className="content">Brak danych o wymiarze urlopu</div>
                            </div>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    limits: state.absence.limits
});

export default connect(mapStateToProps, { getLimits })(AbsenceList);